import { render, staticRenderFns } from "./RegistroAuxilios.vue?vue&type=template&id=65bba378&"
import script from "./RegistroAuxilios.vue?vue&type=script&lang=js&"
export * from "./RegistroAuxilios.vue?vue&type=script&lang=js&"
import style0 from "./RegistroAuxilios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports